// extracted by mini-css-extract-plugin
export default {"layout":"AdminLayout_layout__yDt0Q","content":"AdminLayout_content__ekQyF"};